/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://334doqncw5bc3c5jlrks2um4yy.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-6xpb5jxk5zgolmx4hgtq542dzy",
    "aws_cognito_identity_pool_id": "us-east-1:9c0ee6ea-d7dc-40b2-9e30-48115e290a40",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_vhSz7oRrt",
    "aws_user_pools_web_client_id": "3dqjaik71kvjrvlv17h0ce8i6g",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
